export default {
    GET_HISTORY_CONSTANTS_REQUEST: 'GET_HISTORY_CONSTANTS_REQUEST',
    GET_HISTORY_CONSTANTS_SUCCESS: 'GET_HISTORY_CONSTANTS_SUCCESS',
    GET_HISTORY_CONSTANTS_FAILURE: 'GET_HISTORY_CONSTANTS_FAILURE',

    CREATE_CONSTANTS_REQUEST: 'CREATE_CONSTANTS_REQUEST',
    CREATE_CONSTANTS_SUCCESS: 'CREATE_CONSTANTS_SUCCESS',
    CREATE_CONSTANTS_FAILURE: 'CREATE_CONSTANTS_FAILURE',

    RESET_CONSTANTS_REQUEST: 'RESET_CONSTANTS_REQUEST',
};
